export default __webpack_public_path__ + "static/media/avatar_8.3db23617.svg";